import { jwtDecode } from "jwt-decode";
import { create } from "zustand";

interface DefaultStore {
	token: string | null;
	decodedAccessToken: IAccessToken | null;
	setToken: (token: string | null) => void;
}

export const useDefaultStore = create<DefaultStore>((set) => ({
	token: null,
	decodedAccessToken: null,
	setToken: (token) => {
		set({ token });

		if (token) {
			try {
				set({ decodedAccessToken: jwtDecode<IAccessToken>(token) });
			} catch {
				set({ decodedAccessToken: null });
			}
		} else {
			set({ decodedAccessToken: null });
		}
	},
}));
